$(window).bind('mousewheel', function (event) {
  if (event.originalEvent.wheelDelta >= 0) {
    $('#navbarSupportedContent').addClass('active')
  } else {
    $('#navbarSupportedContent').removeClass('active')
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/_toggleNav.js